import React, { useState, useEffect } from "react";
import {
  FaShareAlt,
  FaWhatsapp,
  FaTrophy,
  FaUserFriends,
  FaClipboard,
  FaCrown,
} from "react-icons/fa";
import "./Referrals.css"; // **Crucial: This is where mobile styles are defined**
import {
  applyReferral,
  getReferredFriends,
  getUserDetails,
  incrementReferralShareCount,
} from "../Services/Service";
import { BottomSheetCustom } from "@cred/neopop-web/lib/components";
import BottomLogin from "./bottomLogin";

const Referrals = () => {
  const [referralCode, setReferralCode] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isError, setIsError] = useState(false);
  const [code, setCode] = useState("");
  const [friendsReferred, setFriendsReferred] = useState([]);
  const [isLoadingFriends, setIsLoadingFriends] = useState(true);
  const [friendsError, setFriendsError] = useState(null);
  const [canApplyCode, setCanApplyCode] = useState("Y");
  const [textLabel, setTextLabel] = useState("Copy Code");
  const [isOpen, setIsOpen] = useState(false);
  const [dailySGEarned, setDailySGEarned] = useState(0);
  const [dailyCap, setDailyCap] = useState(0);
  const DAILY_CAP = 0; // Use a constant for the daily cap
  const [totalPoints, setTotalPoints] = useState(0); // ⭐️ New state for total points
  const isLoggedIn = localStorage.getItem("auth")
    ? localStorage.getItem("auth")
    : "";
  const formatDateTime = (dateString) => {
    try {
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
      const year = String(date.getFullYear()).slice(-2); // Get the last two digits of the year

      return `${day}-${month}-${year}`;
    } catch (e) {
      return "Unknown Date";
    }
  };
  console.log("Is user logged in?", isLoggedIn);
  const [issOpen, setOpen] = useState(false);
  const fetchReferredFriends = async () => {
    setIsLoadingFriends(true);
    setFriendsError(null);

    try {
      const response = await getReferredFriends();
      const { data, message } = response?.data || {};
      if (response.status === 200) {
        const list = Array.isArray(data) ? data : data?.referralList || [];
        setFriendsReferred(list);
        // ⭐️ Calculate total points and update state
        const calculatedTotalPoints = list.reduce(
          (sum, friend) => sum + (friend.points || 0),
          0
        );
        setTotalPoints(data.points);
        setDailySGEarned(data.dailyPoints || 0);
        setDailyCap(data.dailyLimit || 50);
      } else {
        setFriendsReferred([]);
        setTotalPoints(0);
        setFriendsError(message || "No referred friends found.");
      }
    } catch (error) {
      console.error("Error fetching referred friends:", error);
      setFriendsReferred([]);
      setTotalPoints(0);
      setFriendsError("Something went wrong. Please try again.");
    } finally {
      setIsLoadingFriends(false);
    }
  };

  const fetchUserInfo = async () => {
    try {
      const userId = localStorage.getItem("auth");
      if (!userId) return;
      const resp = await getUserDetails(userId);
      const data = resp?.data?.data || {};
      const apiReferralCode = data.refCode;
      const apiCanApply = data.canApplyCode;
      if (apiReferralCode) setReferralCode(apiReferralCode);
      setCanApplyCode(apiCanApply);
    } catch (err) {
      console.error("Error fetching user info for referral:", err);
    }
  };

  const handleRetry = () => {
    fetchReferredFriends();
  };

  useEffect(() => {
    fetchReferredFriends();
    fetchUserInfo();
    // if (!isLoggedIn) {
    //   setOpen(true);
    // }
  }, []);

  const handleCopyCode = () => {
    navigator.clipboard.writeText(referralCode);
    setTextLabel("Copied!");
    setTimeout(() => {
      setTextLabel("Copy Code");
    }, 2000);
  };

  const handleApplyCode = async (code) => {
    setErrorMessage("");
    try {
      const res = await applyReferral(code);
      if (res?.data?.code === 400) {
        setIsError(true);
        setErrorMessage(res?.data?.message);
      } else {
        setIsError(false);
        setErrorMessage(res.data.message);
        if (!friendsError) {
          fetchReferredFriends();
        }
      }
    } catch (err) {
      console.error("Error applying referral code:", err);
      setErrorMessage("An unexpected error occurred. Please try again.");
    }
  };

  const userAgent = navigator.userAgent;
  console.log(userAgent); // Example output: "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/108.0.0.0 Safari/537.36"
  const handleNativeShare = async () => {
    if (navigator.share) {
      try {
        const message = `Hey FAUG!

Refer your friends & earn IceSpice (Rewards) — play together, win together!

How it works:
1. Share your referral code: ${referralCode}
2. Your friend joins & plays
3. You BOTH earn 5 spicegold!

Redeem your spicegold for rewards & exclusive gear!

Download now: https://play.google.com/store/apps/details?id=com.dotnine.faug`;

        await navigator.share({
          // The title can be simpler too, just in case
          title: `Join FAUG with code ${referralCode} & Get 5 Spicegold!`,
          text: message, // Uses the updated plain-text message
          url: `https://play.google.com/store/apps/details?id=com.dotnine.faug`,
        });

        // Increment share count after successful share
        if (referralCode) {
          try {
            await incrementReferralShareCount(referralCode);
          } catch (error) {
            console.error("Error incrementing share count:", error);
          }
        }
      } catch (error) {
        console.error("Error sharing:", error);
      }
    } else {
      handleShareOnWhatsapp();
    }
  };

  const handleShareOnWhatsapp = async () => {
    const message = encodeURIComponent(
      `Hey FAUG!

Refer your friends & earn IceSpice (Rewards) — play together, win together!

How it works:
1. Share your referral code: ${referralCode}
2. Your friend joins & plays
3. You BOTH earn 5 spicegold!

Redeem your spicegold for rewards & exclusive gear!

Download now: https://play.google.com/store/apps/details?id=com.dotnine.faug`
    );

    const whatsappLink = `https://wa.me/?text=${message}`;
    window.open(whatsappLink, "_blank");

    // Increment share count after opening WhatsApp
    if (referralCode) {
      try {
        await incrementReferralShareCount(referralCode);
      } catch (error) {
        console.error("Error incrementing share count:", error);
      }
    }
  };
  return (
    <div className=" content-app referrals-container pt-4">
      {/* Login Overlay */}
      {!isLoggedIn && !issOpen && (
        <div
          style={{
            width: "100%",
            height: "90%",
            position: "fixed",
            zIndex: 1000,
            backdropFilter: "blur(12px)",
            WebkitBackdropFilter: "blur(12px)",
            backgroundColor:
              "rgba(0, 0, 0, 0.5)" /* Added a semi-transparent overlay */,
          }}
          className="position-fixed top-0 start-0 w-100 h-92 d-flex justify-content-center align-items-center"
        >
          <div
            className="text-center p-5 rounded-3"
            style={{
              maxWidth: "400px",
              backgroundColor: "rgba(255, 255, 255)",
              color: "#000",
              boxShadow: "0 4px 15px rgba(0, 0, 0, 0.2)",
            }}
          >
            <h2 className="text-3xl md:text-4xl font-extrabold mb-4 animate-pulse text-dark">
              Please Log In
            </h2>
            <p className="mb-0">Dear User,</p>
            <p className="text-xl md:text-xl text-white-500 mb-8">
              To refer your friends to play{" "}
              <span className="font-bold">FAU-G</span> and earn{" "}
              <span className="font-bold">
                SpiceGold (SG){" "}
                <img
                  src={"/assets/images/spicegold.png"}
                  alt=""
                  style={{
                    height: "25px",
                    width: "25px",
                  }}
                />{" "}
                rewards
              </span>
              ,<p> please register with IceSpice.</p>
            </p>
            <button
              onClick={() => setOpen(true)}
              className="btnPrimary py-2 px-6 rounded-lg text-white font-semibold transition-all duration-300 transform hover:scale-105 shadow-lg"
              style={{
                background:
                  "linear-gradient(45deg, #4F46E5, #8B5CF6)" /* Modern gradient */,
                border: "none",
              }}
            >
              Log In
            </button>
          </div>
        </div>
      )}
      <div className="referral-section mt-3 text-center">
        <h2 className="title">Your Referral Code</h2>
        <p className="subtitle text-dark mt-1">
          Share your code with friends and earn rewards!
        </p>
        <div className="referral-code-box">
          {referralCode === "" ? (
            <span className="code no-code">No Code Available</span>
          ) : (
            <div className="d-flex align-items-center justify-content-center gap-2">
              {" "}
              <span className="code">
                <span className="ref-text">{referralCode}</span>
                <button
                  onClick={handleCopyCode}
                  className={`inline-copy-btn copy-btn-dynamic ${
                    textLabel === "Copied!" ? "copied" : ""
                  }`}
                >
                  <FaClipboard />
                  {/* <p><small>{textLabel}</small></p> */}
                </button>
              </span>
            </div>
          )}
          {textLabel === "Copied!" && (
            <span className="copied-text text-dark "> Code Copied!</span>
          )}
          <div className="referral-actions">
            <button
              onClick={handleShareOnWhatsapp}
              className="action-btn whatsapp-btn"
            >
              <FaWhatsapp /> Share
            </button>
            <button onClick={handleNativeShare} className="action-btn ">
              <FaShareAlt /> Share
            </button>
          </div>
        </div>
      </div>

      <div className="card text-white bg-dark p-2 rounded-2 shadow">
        <p className="card-text text-light mb-0">
          Share this code with your friends and earn rewards when they sign up!
        </p>
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="btn btn-link text-warning text-decoration-none d-flex align-items-center gap-1"
        >
          <span>{isOpen ? "Hide details" : "Show details"}</span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            className={`arrow-icon ${isOpen ? "rotate-180" : ""}`}
            style={{
              width: "1rem",
              height: "1rem",
              transition: "transform 0.3s ease-in-out",
            }}
          >
            <path
              fillRule="evenodd"
              d="M12.53 16.28a.75.75 0 0 1-1.06 0l-7.5-7.5a.75.75 0 0 1 1.06-1.06L12 14.69l6.97-6.97a.75.75 0 1 1 1.06 1.06l-7.5 7.5Z"
              clipRule="evenodd"
            />
          </svg>
        </button>
        <div
          className={`collapse ${isOpen ? "show" : ""}`}
          id="referral-details"
        >
          <div className="mt-1 p-2 bg-secondary rounded space-y-3">
            <div className="d-flex align-items-start gap-2 text-sm text-light">
              1.
              <p>
                Both the referrer and the friend will earn 5 spiceGold once your
                friend successfully signs up.
              </p>
            </div>
            <div className="d-flex align-items-start gap-2 text-sm text-light">
              2.
              <p>
                The daily referral limit is 10 friends (50 spiceGold). Any
                further referrals will not earn a reward on that day.
              </p>
            </div>
            <div className="d-flex align-items-start gap-2 text-sm text-light">
              3.
              <p>Referral codes cannot be combined with other offers.</p>
            </div>
            <div className="d-flex align-items-start gap-2 text-sm text-light">
              4.
              <p>
                Rewards will be credited once your friend successfully signs up.
              </p>
            </div>
            <div className="d-flex align-items-start gap-2 text-sm text-light">
              5.
              <p>
                Company reserves the right to modify or end the referral program
                at any time.
              </p>
            </div>
          </div>
        </div>
      </div>

      {canApplyCode !== "N" && (
        <div className="referral-section mt-3">
          <h2 className="title">Apply Referral Code</h2>
          <div className="enter-code-box">
            <input
              type="text"
              placeholder="Enter referral code"
              className="referral-input mt-3"
              onChange={(e) => setCode(e.target.value)}
            />
            <button
              className="submit-btn"
              onClick={() => handleApplyCode(code)}
            >
              Apply
            </button>
          </div>
          {errorMessage && (
            <p
              className={
                isError ? "error-message mt-3" : "success-message mt-3"
              }
            >
              {errorMessage}
            </p>
          )}
        </div>
      )}

      <div className="daily-progress-section mt-4">
        <h3 className="title text-warning fw-bold">Daily Referral Progress</h3>
        <div className="progress-container bg-shine">
          <div
            className="progress-bar"
            style={{
              width: `${Math.min((dailySGEarned / dailyCap) * 100, 100)}%`,
              background: `linear-gradient(90deg, #FFD700, #FFA500)`,
            }}
          ></div>
        </div>
        <div className="progress-info">
          <span className="current-sg text-warning">
            {dailySGEarned}
            <img
              src={"/assets/images/spicegold.png"}
              alt=""
              style={{
                height: "30px",
                width: "30px",
              }}
            />{" "}
            {/* <FaTrophy />   */}
          </span>
          <span className="cap"> / {dailyCap} SG Daily Cap</span>
        </div>
        <div className="progress-message text-danger mt-2">
          {dailySGEarned >= dailyCap
            ? "You have reached your daily cap! Come back tomorrow."
            : "Keep Going!"}{" "}
        </div>
      </div>

      {/* ⭐️ Total Earned Points Section - Uses flex-wrap for mobile stacking */}
      <div className="total-points-section d-flex justify-content-center gap-2 mb-4 flex-wrap">
        <div className="card-points">
          <div className="d-flex justify-content-center align-items-center">
            {" "}
            <div className="icon-wrapper">
              <FaTrophy className="icon trophy-icon" />
            </div>
          </div>

          <div className="points-info mt-3">
            <span className="points-value d-flex align-items-center justify-content-center">
              {totalPoints}{" "}
              <img
                src={"/assets/images/spicegold.png"}
                alt=""
                style={{
                  height: "40px",
                  width: "40px",
                }}
              />
            </span>
            <span className="points-label d-flex align-items-center justify-content-center">
              SpiceGold Earned
            </span>
          </div>
        </div>
        <div className="card-points">
          <div className="d-flex justify-content-center align-items-center">
            {" "}
            <div className="icon-wrapper">
              <FaUserFriends className="icon friends-icon" />
            </div>
          </div>

          <div className="points-info mt-3">
            <span className="points-value d-flex justify-content-center align-items-center">
              {friendsReferred.length}
            </span>
            <span className="points-label d-flex justify-content-center align-items-center">
              Friends Referred
            </span>
          </div>
        </div>
      </div>

      <div className="referral-section-list">
        <h2 className="title mb-3">Referred Friends</h2>
        {isLoadingFriends ? (
          <p className="no-referrals">Loading referred friends...</p>
        ) : friendsError ? (
          <div className="error-container">
            <p className="error-message mt-3">{friendsError}</p>
            <div style={{ textAlign: "center", marginTop: "15px" }}>
              <button
                onClick={handleRetry}
                className="submit-btn"
                style={{
                  padding: "10px 20px",
                  fontSize: "0.9rem",
                  background: "linear-gradient(90deg, #3498db, #2980b9)",
                }}
                disabled={isLoadingFriends}
              >
                {isLoadingFriends ? "Retrying..." : "Retry"}
              </button>
            </div>
          </div>
        ) : friendsReferred.length > 0 ? (
          <div className="table-container">
            {/* Note: Removed table header for better mobile layout, relying on row data */}
            {friendsReferred.map((friend, index) => {
              const name = friend.firstName || "Unknown User";
              const date = formatDateTime(friend.createdTime);
              const isLocked =
                !friend.rewardValue ||
                (friend.rewardValue <= 0 && friend.rewardStatus !== "both");

              return (
                <div key={index} className="table-row text-black ">
                  <div className="row g-0 align-items-center">
                    {/* Index */}
                    <div className="col-1 col-sm-1 text-center">
                      <span className="fw-bold">{index + 1}.</span>
                    </div>
                    {/* Name (Mobile col-4, Tablet/Desktop col-4) */}
                    <div className="col-4 col-sm-4 text-truncate">
                      <span className="d-sm-none fw-bold me-1"></span> {name}
                    </div>
                    {/* Date (Mobile col-4, Tablet/Desktop col-4) */}
                    <div className="col-4 col-sm-4 text-truncate">
                      <span
                        className=" fw-bold me-1"
                        style={{ fontSize: "10px !important" }}
                      ></span>{" "}
                      {date}
                    </div>
                    {/* Status (Mobile col-2, Tablet/Desktop col-2) */}
                    <div className="col-2 col-sm-2 text-center mt-2 mt-sm-0">
                      <span className="d-sm-none fw-bold me-1"></span>
                      {isLocked ? (
                        <span className="status-locked">🔒 </span>
                      ) : (
                        <span className="status-unlocked">
                          <FaTrophy /> {friend.rewardValue}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <p className="no-referrals">
            You haven't referred anyone yet. Start sharing your code!
          </p>
        )}
      </div>
      <hr />
      <BottomSheetCustom
        open={issOpen}
        handleClose={() => setOpen(!issOpen)}
        maxHeight="700px"
      >
        <BottomLogin onClose={() => setOpen(!issOpen)} />
      </BottomSheetCustom>
    </div>
  );
};

export default Referrals;
